import React from 'react';
import { FormControlLabel as MuiFormControlLabel } from '@material-ui/core';

const FormControlLabel = props => <MuiFormControlLabel {...props} />;

export default FormControlLabel;
